export const appartenenze = [ {
        min: 0,
        max: 2
    }, {
        min: 3,
        max: 5
    }, {
        min: 6,
        max: 7
    }, {
        min: 8,
        max: 10
    }, {
        min: 11,
        max: 13
    }, {
        min: 14,
        max: 16
    }, {
        min: 17,
        max: 18
    }, {
        min: 19,
        max: 21
    }, {
        min: 22,
        max: 24
    }, {
        min: 25,
        max: 27
    }, {
        min: 28,
        max: 90
    }, {
        min: 30,
        max: 32
    }, {
        min: 33,
        max: 35
    }, {
        min: 36,
        max: 38
    }, {
        min: 39,
        max: 40
    }, {
        min: 41,
        max: 43
    }, {
        min: 44,
        max: 46
    }, {
        min: 47,
        max: 49
    }, {
        min: 50,
        max: 52
    }
];



/** WEBPACK FOOTER **
 ** ./components/appartenenze.js
 **/